import { CommunicationsLog } from '../model/communications-log';
export class CommunicationsLogBuilder {
    static buildCommunicationsLog(data) {
        const communicationsLog = new CommunicationsLog();
        communicationsLog.id = data.id;
        communicationsLog.id_reservation = data.id_reservation;
        communicationsLog.id_client = data.id_client;
        communicationsLog.id_agency = data.id_agency;
        communicationsLog.id_company = data.id_company;
        communicationsLog.description = data.description;
        communicationsLog.description_string = data.description_string;
        communicationsLog.timestamp = data.timestamp;
        communicationsLog.status = data.status;
        communicationsLog.status_string = data.status_string;
        communicationsLog.response = data.response;
        communicationsLog.email = data.email;
        communicationsLog.phone = data.phone;
        return communicationsLog;
    }
}
//# sourceMappingURL=communications-log-builder.js.map